<template>
  <v-dialog
    :value="value"
    max-width="1300"
    width="1300"
    persistent
    @click:outside="$emit('close')">
    <v-card tile flat>
      <v-card-title class="px-5 pt-4">
        Promo Item Groups
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="selected.length === 0"
          @click="addGroups">
          Add
        </v-btn>
        <v-btn class="ml-2" icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
       <v-container fluid class="ma-0 pa-0">
        <v-data-table
          :headers="tableHeaders"
          :items="promoItemGroups"
          dense
          :height="tableHeight"
          group-by="promo_item_group.id"
          fixed-header
          :loading="loading"
          :items-per-page="-1"
          :custom-sort="customSort"
          :footer-props="{'items-per-page-options': [-1]}"
          loading-text="Searching Available Data...Please Wait"
          loader-height="5"
          no-data-text="No Data to Display">
          <template v-slot:[`header.select-all`]>
            <v-checkbox
              v-model="allSelected"
              class="my-auto mx-0"
              hide-details
              dark
              :disabled="availableGroupIds.length === 0"
              :ripple="false"
              @change="selectAll">
            </v-checkbox>
          </template>
          <template #[`group.header`]="{ items, headers}">
            <td :colspan="headers.length">
              <v-row align="center">
                <v-col cols="auto">
                  <v-icon v-if="featureGroupIds.some(id => id === items[0].promo_item_group.id)" color="success">
                    mdi-check
                  </v-icon>
                  <template v-else>
                    <v-checkbox
                      v-model="selected"
                      :value="items[0].promo_item_group.id"
                      color="primary"
                      class="my-auto mx-0"
                      hide-details
                      :ripple="false">
                    </v-checkbox>
                  </template>
                </v-col>
                <v-col class='truncate'>
                  <span><b>Promo Item Group</b><br></span>
                  <span v-if='items[0].promo_item_group.name'>
                    {{items[0].promo_item_group.name}}
                  </span>
                  <span v-else>N/A</span>
                </v-col>
                <v-col class='truncate'>
                  <span>
                    <b>Promo Name</b><br>
                    {{selectedPromo.name}}
                  </span>
                </v-col>
                <v-col>
                  <span>
                    <b>Promo Category</b><br>
                    {{selectedPromo.promo_category_name}}
                  </span>
                </v-col>
                <v-col>
                  <span>
                    <b>Promo Start Date</b><br>
                    {{formatDateDisplay(selectedPromo.start_dt)}}
                  </span>
                </v-col>
                <v-col>
                  <span>
                    <b>Promo End Date</b><br>
                    {{formatDateDisplay(selectedPromo.end_dt)}}
                  </span>
                </v-col>
              <v-col>
                  <span>
                    <b>Billing Mode</b><br>
                    {{selectedPromo.billing_mode_name}}
                  </span>
                </v-col>
              </v-row>
            </td>
          </template>
          <template #[`item.promotion_price`]="{ item }">
            <span v-if="item.promo_item_group.promotion_price">${{formatCurrencyDisplay(item.promo_item_group.promotion_price)}}</span>
            <span v-else-if="selectedPromo.promotion_price">${{formatCurrencyDisplay(selectedPromo.promotion_price)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.rebate_amount`]="{ item }">
            <span v-if="item.promo_item_group.rebate_amount">${{formatCurrencyDisplay(item.promo_item_group.rebate_amount)}}</span>
            <span v-else-if="selectedPromo.rebate_amount">${{formatCurrencyDisplay(selectedPromo.rebate_amount)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.billback_allowance`]="{ item }">
            <span v-if="item.accrual_amt">${{formatCurrencyDisplay(item.accrual_amt)}}</span>
            <span v-else-if="item.promo_item_group.billback_allowance">${{formatCurrencyDisplay(item.promo_item_group.billback_allowance)}}</span>
            <span v-else-if="selectedPromo.billback_allowance">${{formatCurrencyDisplay(selectedPromo.billback_allowance)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.amap_allowance`]="{ item }">
            <span v-if="item.promo_item_group.amap_allowance">${{formatCurrencyDisplay(item.promo_item_group.amap_allowance)}}</span>
            <span v-else-if="selectedPromo.amap_allowance">${{formatCurrencyDisplay(selectedPromo.amap_allowance)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.early_buy_allowance`]="{ item }">
            <span v-if="item.promo_item_group.early_buy_allowance">${{formatCurrencyDisplay(item.promo_item_group.early_buy_allowance)}}</span>
            <span v-else-if="selectedPromo.early_buy_allowance">${{formatCurrencyDisplay(selectedPromo.early_buy_allowance)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.item.sale_price`]="{ item }">
            <span v-if="item.item.sale_price">${{formatCurrencyDisplay(item.item.sale_price)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.item.cost`]="{ item }">
            <span v-if="item.item.cost">${{formatCurrencyDisplay(item.item.cost)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.item.unit_cost`]="{ item }">
              <span v-if="item.item.qty_per_case">  ${{formatCurrencyDisplay(calcUnitCost(item))}} </span>
              <span v-else> - </span>
            </template>
        </v-data-table>
       </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
// Mixins
import { displayAlert } from '@/mixins/alert'
import { format } from '@/mixins/format'
import { userAccess } from '@/mixins/user-access'
export default {
  data() {
    return {
      allSelected: false,
      selected: [],
      headerProps: { sortable: false, class: 'accent white--text' }
    }
  },
  name: 'PromoItemGroupsModal',
  mixins: [displayAlert, format, userAccess],
  props: {
    value: Boolean,
    loading: Boolean,
    feature: Object,
    selectedPromo: Object,
    tableHeight: Number,
    promoItemGroups: Array
  },
  computed: {
    headers() {
      return [
        { value: 'select-all' },
        { text: 'Item ID', value: 'item.item_id' },
        { text: 'Source', value: 'item.source' },
        { text: 'Name', value: 'item.description' },
        { text: 'Promotion Price', value: 'promotion_price' },
        { text: 'Scan Allowance', value: 'rebate_amount' },
        { text: 'Billback Allowance', value: 'billback_allowance' },
        { text: 'AMAP Allowance', value: 'amap_allowance' },
        { text: 'Early Buy Allowance', value: 'early_buy_allowance' },
        { text: 'Regular Retail', value: 'item.sale_price' },
        { text: 'Case Cost', value: 'item.cost' },
        { text: 'Net Unit Cost', value: 'item.unit_cost' },
        { text: 'Pack Size', value: 'item.pack_size' },
      ]
    },
    tableHeaders() {
      return this.headers.map(header => ({ ...header, ...this.headerProps }))
    },
    featureGroupIds() {
      return this.feature.promo_item_group_ids
    },
    groupIds() {
      if (this.promoItemGroups.length > 0) {
        return [...new Set(this.promoItemGroups.map(pig => pig.promo_item_group.id))]
      }
      return []
    },
    availableGroupIds() {
      return this.groupIds.filter(id => this.featureGroupIds.includes(id) === false)
    }
  },
  methods: {
    customSort (items) {
      return items.sort((a, b) => String(a.promo_item_group.id).localeCompare(b.promo_item_group.id) || String(a.item_id).localeCompare(b.item_id))
    },
    selectAll(value) {
      this.selected = (value === true) 
        ? [...this.availableGroupIds] 
        : []
    },
    addGroups () {
      this.$emit('addPromoItemGroups', this.selected)
    },
    calcUnitCost(item) {
      if (item.accrual_amt) {
        return ((item.item.cost - (item.promo_item_group.rebate_amount + item.accrual_amt + item.promo_item_group.amap_allowance + item.promo_item_group.early_buy_allowance)) / item.item.qty_per_case)
      }
      if (this.selectedPromo.promo_type_constant === 'BILLBACK') {
        return ((item.item.cost - (item.promo_item_group.rebate_amount + item.promo_item_group.billback_allowance + item.promo_item_group.amap_allowance + item.promo_item_group.early_buy_allowance)) / item.item.qty_per_case)
      } else {
        return (item.item.cost / item.item.qty_per_case - (item.promo_item_group.rebate_amount + item.promo_item_group.billback_allowance + item.promo_item_group.amap_allowance + item.promo_item_group.early_buy_allowance))
      }
    }
  }
}
</script>